import { type IFramework } from '@/framework';
import { createForeignObjectImageUrl, serializerHtmlToString, serializeSvgText } from '@/utils/file-kit';
import { LIST_CHAR_ALL, type ILayerProps, type ITextLayerProps } from '@/version-types';

/**
 * 创建 svg 类型的 list marker svg
 * @param source - svg 字符串
 * @param layer - 矢量图层
 * @returns - 图片信息
 */
export const createListMarkerSVGDataURL = (source: string, layer: ILayerProps) => {
    const layerData = layer.data as ITextLayerProps;
    const config = layerData.listStyleMaterial!;
    const { iconWidth, iconHeight, iconColors } = config;

    let svgString = source;

    // 替换颜色
    const flatColors: string[] = [];

    iconColors.forEach((item) => {
        const { color, values } = item;
        values.forEach((val) => {
            flatColors[val] = color;
        });
    });

    if (flatColors.length > 0) {
        flatColors.forEach((color, idx) => {
            svgString = svgString.replace(`{{colors[${idx}]}}`, `${color}`);
        });
    }

    const ret = createForeignObjectImageUrl(
        iconWidth,
        iconHeight,
        serializerHtmlToString(serializeSvgText(svgString)),
        true,
    );

    return ret;
};

/**
 * 获取列表序号字体
 * @param framework - 框架实例
 * @param fontID - 字体 ID
 * @returns - 字体信息
 */
export const getListOrderFontFamily = (framework: IFramework, fontID: string) => {
    const fontList = framework.getFontList();
    const font = fontList.find((item) => String(item.id) === fontID);

    if (!font) return null;

    return font['font_name'];
};
